import React, { Component } from 'react'; //different
import MainSettingContext from './MainSettingContext';
import '../App.css';
import Swal from 'sweetalert2'
import instance from "../axios-instance";
import Systems from "../SystemFunction";
import { t } from './i18n';
class App extends Component {
    static contextType = MainSettingContext;
    get lang() { return this.props.language || this.context?.language || localStorage.getItem('lang') || 'th'; }

  constructor(props) {
    super(props)
    this.state = {
      point: props.point || 0,
      rankpoint: 0,
      remaining_amount: props.remaining_amount || 0,
      tblwheelsetting: [],
      name: "",
      tabselect: 0,
      password: "",
      left: false,
      disable: false,
      segColors: null,
      segments: null,
      spinning: false,
      rotation: 0,
      activeKey: null,
      centerImg: ''
    }
  }

  // ===== หมุนกงล้อ =====
  // ธีมอื่นใช้ jQuery ใน public/index.html ผูกปุ่ม .js-wheel-button — ธีมนี้ไม่มีสคริปต์นั้น ปุ่มเลยกดไม่ได้
  // ย้ายมาทำใน React: เรียก /api/v1/postwheelspin (ส่ง token แบบ form เหมือนเดิม) แล้วหมุนไปช่องที่ได้ (สูตรเดียวกับธีมอื่น)
  playSound(id, stop) {
    const audio = document.getElementById(id);
    if (!audio) return;
    try { audio.currentTime = 0; const p = audio.play(); if (p && p.catch) p.catch(() => { }); } catch (e) { /* ignore */ }
    setTimeout(() => { try { audio.pause(); audio.currentTime = 0; } catch (e) { /* ignore */ } }, stop);
  }
  spin = async () => {
    if (this.state.spinning || !(Number(this.state.point) > 0)) return;
    const token = localStorage.getItem('auth_token');
    if (!token) { this.handleNav('/login'); return; }
    this.setState({ spinning: true, activeKey: null });
    let res;
    try {
      res = (await instance.post('/api/v1/postwheelspin', new URLSearchParams({ token }))).data || {};
    } catch (e) {
      this.setState({ spinning: false });
      Swal.fire({ icon: 'error', title: t(this.lang, 'm_game_not_available'), confirmButtonText: t(this.lang, 'ok') });
      return;
    }
    if (res.status != 200) {
      this.setState({ spinning: false });
      Swal.fire({ title: 'Warning!', text: res.message && typeof res.message === 'string' ? res.message : 'คุณหมุนกงล้อครบจำนวนครั้งของวันนี้แล้ว', icon: 'warning', confirmButtonText: t(this.lang, 'ok') });
      return;
    }
    const len = (this.state.segments && this.state.segments.length) || 8;
    const rotateScale = 360 / len;
    const rewardKey = Number(res.reward_key) || 0;
    let pos = this.state.rotation + 10 * 360 + Math.floor(Math.random() * 360);
    pos += (360 - (pos % 360)) + (360 - ((rotateScale * rewardKey) % 360)) + 45;
    const reward = res.reward || {};
    this.setState({ rotation: pos, point: res.event_balance != null ? res.event_balance : this.state.point, centerImg: '' });
    this.playSound('sfx-wheel-spinning', 6800);
    setTimeout(() => {
      this.setState({ spinning: false, activeKey: rewardKey, centerImg: reward.image || '' });
      this.playSound('sfx-wheel-got-reward', 6500);
      if (reward.name) {
        Swal.fire({ icon: 'success', title: t(this.lang, 'm_congratulations'), text: reward.name, imageUrl: reward.image || undefined, imageHeight: reward.image ? 90 : undefined, confirmButtonText: t(this.lang, 'ok') });
      }
    }, 7000);
  }
  handleNav(to, e = { preventDefault: () => { } }) {
    // ถ้า e ถูกส่งมาจาก onClick ปกติ
    if (e?.preventDefault) e.preventDefault();

    // รองรับ ctrl / alt / middle click
    if (e?.metaKey || e?.ctrlKey || e?.shiftKey || e?.altKey || e?.button === 1) return;

    console.log("📍 Navigate to:", to);

    if (typeof this.props.onNavigate === "function") {
      this.props.onNavigate(to, e);
    } else {
      // fallback
      window.history.pushState(null, "", to);
      window.dispatchEvent(new PopStateEvent("popstate"));
    }
  }
  componentDidUpdate(prevProps, prevState) {
    const { point, userid } = this.props; // destructuring for easier access

    // Check if point has changed
    if (prevProps.point !== point) {
      if (point !== this.state.point) {
        console.log("componentDidUpdate - point updated:", point);
        this.setState({ point });
      }
    }

    // Check if username has changed
    if (prevProps.userid !== userid) {
      if (userid !== this.state.userid) {
        console.log("componentDidUpdate - username updated:", userid);
        this.setState({ userid: userid });
      }
    }

    // Sync ยอดสะสม (remaining_amount) จาก prop เมื่อ parent โหลด profile เสร็จ
    if (prevProps.remaining_amount !== this.props.remaining_amount) {
      this.setState({ remaining_amount: this.props.remaining_amount || 0 });
    }
  }

  componentDidMount() {
    this.getwheel();
  }
  getwheel = async () => {
    // var segments = [{ id: 1, name: '5 บาท' }, { id: 2, name: '100 บาท' }, { id: 3, name: '300 บาท' }, { id: 4, name: '10 บาท' }, { id: 5, name: '20 บาท' }, { id: 6, name: 'คร้งหน้านะ บาท' }, { id: 7, name: 'เกือบได้แล้ว' }, { id: 8, name: 'ครั้งหน้านะ' }, { id: 9, name: '1000 บาท' }];
    try {
      await instance.post("/api/v1/getwheelspin", {
        System: Systems,
      }).then(async (res) => {
        console.log("getwheelspin", res.data)
        if (res.data.status === 200) {
          const datas = res.data.message;
          var segments = []
          var segColors = []
          // สีสำรองเมื่อ BO ไม่ได้ตั้งสี (color ว่าง) สลับสองเฉดให้ช่องวงล้อเห็นชัด อ่าน label ออก
          var defaultWheelColors = ['#1f2937', '#b45309', '#374151', '#d97706', '#111827', '#f59e0b', '#4b5563', '#92400e']

          if (res.data.tblwheelsetting.length > 0 && res.data.tblwheelsetting[0].status == 0) {
            await Swal.fire({
              icon: 'error',
              title: t(this.lang, 'm_game_not_available'),
              showConfirmButton: true,
              confirmButtonText: t(this.lang, 'ok')
            });
            this.handleNav('/event')
          }
          for (var i = 0; i < datas.length; i++) {
            var id = datas[i].id
            var name = datas[i].description
            var color = (datas[i].color && String(datas[i].color).trim()) ? datas[i].color : defaultWheelColors[i % defaultWheelColors.length]
            var image = datas[i].image
            var setp = { id, name, image }
            segments.push(setp)
            segColors.push(color)
          }
          console.log(segColors)
          this.setState({
            tblwheelsetting: res.data.tblwheelsetting,
            segments: segments,
            segColors: segColors,
          });
          console.log(61, segments)

        }
        else {
          // this.CheckThisGoalError();
        }
      });
    }
    catch (error) {
      console.log(error)
    }

  }

  render() {
    // console.log(555555, this.state.segments)
    const { tabselect } = this.state
    return (
      <>
        <div className="animated animatedFadeInUp fadeInUp mt-2">
          <div className="row m-0 border-shadow-title" style={{ display: tabselect == 0 ? "" : "none" }}>
            <div className="col-12 p-0 col-sm-7 col-md-7 col-lg-7 col-xl-7 mx-auto my-auto text-white-v1">
              <div className="text-center bg-title-web" style={{ paddingTop: 50 }}>
                <div>
                  <div className="text-title text-white-v1 text-center">
                    <div className="d-flex justify-content-between">
                      <div className="text-white-v1-deposit">
                        <a role="button" onClick={(e) => this.handleNav('/event')}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            fill="currentColor"
                            className="bi bi-arrow-left-circle text-color-back"
                            viewBox="0 0 16 16"
                          >
                            <path
                              fillRule="evenodd"
                              d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z"
                            />
                          </svg>
                        </a>
                      </div>
                      <div className="text-white-v1-deposit">
                        <h5>{t(this.lang, 'm_wheel_event')}</h5>
                      </div>
                      <div>
                        <div className="text-white-v1-deposit">
                          <h5 role="button" className="text-title-navbar">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width={20}
                              height={20}
                              fill="currentColor"
                              className="text-white-v1-deposit bi bi-card-list"
                              viewBox="0 0 16 16"
                            >
                              <path d="M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h13zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13z" />
                              <path d="M5 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 5 8zm0-2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0 5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-1-5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zM4 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm0 2.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z" />
                            </svg>
                          </h5>
                        </div>
                      </div>
                    </div>
                    <hr className="mt-0" />
                  </div>
                </div>
              </div>
              <div className="-full-flex-wrap ">
                <div className="-full-flex-inner-bg -bg" style={{ backgroundImage: 'url(/build/web/igame-index-lobby-wm/img/index-bg.jpg?v=1)' }}>
                  <div className="x-lucky-wheel-share-component  x-bg-position-center lazyloaded" data-bgset="/build/web/igame-index-lobby-wm/img/wheel-page-bg.jpg?v=1" style={{ backgroundImage: 'url("/build/web/igame-index-lobby-wm/img/wheel-page-bg.jpg?v=1")' }}>
                    <div className="container position-relative">
                      <div className="-btn-info-wrapper animated fadeInUp" data-animatable="fadeInUp">
                        {/* <button className="btn -btn-info " data-ajax-modal-ondemand-user="lucky-wheel-modal-history" data-force="true" data-x-dismiss="true" data-parent-class-selector="x-lucky-wheel-history-modal -v2" data-url="/_ajax_/lucky-fortune/history?promotionId=9">
                          <i className="fas fa-history" />
                        </button>
                        <button className="btn -btn-info " data-toggle="modal" data-target="#luckyWheelConditionModal">
                          <i className="fas fa-info-circle" />
                        </button> */}
                      </div>
                    </div>
                    <div className="text-center mb-4">
                      <h1 className="-heading-title animated fadeInUp" data-animatable="fadeInUp">{t(this.lang, 'm_wheel_title')}</h1>
                    </div>
                    <div className="container">
                      <div id="wheel" data-animatable="fadeInUp" data-delay={250} className="x-wheel-container x-bg-position-center lazyloaded animated fadeInUp" data-bgset="https://asset.cloudigame.co/build/admin/img/wt_theme/ezc/wheel-bg.png" style={{ backgroundImage: 'url("https://asset.cloudigame.co/build/admin/img/wt_theme/ezc/wheel-bg.png")' }}>
                        <img alt="Website name Image" className="-wheel-ring" width={528} height={528} src="https://asset.cloudigame.co/build/admin/img/wt_theme/ezc/wheel-ring.png" />
                        <div className="-center-pin">
                          <img alt="Website name Image" className="-wheel-pin" width={112} height={171} src="https://asset.cloudigame.co/build/admin/img/wt_theme/ezc/wheel-pin.png" />
                          <img src={this.state.centerImg || undefined} alt={t(this.lang, 'lucky_wheel_alt')} id="rewardImgCenter" className={"-reward-img" + (this.state.centerImg ? " -loaded" : "")} />
                        </div>
                        {(this.state.segments === null || this.state.segments.length == 0) ? "" :
                          <div className={"x-wheel-inner-wrapper -length-" + (this.state.segments.length)} style={{ "--wheel-length": (this.state.segments.length) }} >
                            <div id="wheelSpinner" className="-spinner" style={{ transform: 'rotate(' + this.state.rotation + 'deg)', transition: 'transform 7s cubic-bezier(.17,.67,.12,.99)' }}>
                              {this.state.segments.map((listitem, i) => (
                                <div key={listitem.id || i} id={"wheelRewardKey_" + listitem.id} className={"-wheel-section whell" + listitem.id + (this.state.activeKey === i ? " -active" : "")} style={{ "--wheel-index": i }}  >
                                  <div className="-wheel-content-wrapper">
                                    <div className="-text">{listitem.name}</div>
                                    <img src={listitem.image} className="-img" alt={t(this.lang, 'lucky_wheel_alt')} width={30} height={30} />
                                  </div>
                                </div>

                              ))}
                            </div>
                          </div>
                        }

                      </div >
                      <button type="button" onClick={this.spin} className={this.state.point > 0 && !this.state.spinning ? "btn -btn-spin js-wheel-button animated fadeInUp" : "btn -btn-spin js-wheel-button disabled animated fadeInUp"}
                        data-animatable="fadeInUp" data-delay={200} disabled={this.state.point <= 0 || this.state.spinning}>
                        <span className="-text ">{t(this.lang, 'spin_wheel_btn')}</span>
                        <img alt="Website name Image" className="img-fluid" width={30} height={30} src="https://asset.cloudigame.co/build/admin/img/wt_theme/ezc/wheel-ticket.png" />
                        <span className="-text js-spin-ticket">{this.state.point}</span>
                      </button>
                      <audio id="sfx-wheel-spinning" src="https://asset.cloudigame.co/build/admin/img/wt_theme/ezl/sfx-wheel-spinning.mp3" />
                      <audio id="sfx-wheel-got-reward" src="https://asset.cloudigame.co/build/admin/img/wt_theme/ezl/sfx-wheel-got-reward.mp3" />
                    </div >
                    <div className="x-wheel-progress-wrapper">
                      <div className="container">
                        <div className="-inner-wrapper animated fadeInUp" data-animatable="fadeInUp">
                          <div>{t(this.lang, 'm_wheel_min_deposit_ticket').replace('{n}', this.state.tblwheelsetting.length > 0 ? this.state.tblwheelsetting[0].amount : 0)}</div>
                          <div className="progress -progress mt-2">
                            <div
                              className="progress-bar"
                              role="progressbar"
                              style={{
                                width:
                                  this.state.tblwheelsetting.length > 0 && this.state.tblwheelsetting[0].amount > 0
                                    ? (this.state.remaining_amount / this.state.tblwheelsetting[0].amount) * 100 + '%'
                                    : '0%', // Default to 0% if amount is not available
                              }}
                              aria-valuenow={0}
                              aria-valuemin={0}
                              aria-valuemax={100}
                            />

                            {/* <div className="progress-bar -progress-bar" role="progressbar" style={{ width: (this.state.remaining_amount-this.state.tblwheelsetting[0].amount ) +'%' }} aria-valuenow={0} aria-valuemin={0} aria-valuemax={100} /> */}
                            <span className="-label">{this.state.remaining_amount}/{this.state.tblwheelsetting.length > 0 ? this.state.tblwheelsetting[0].amount : 0} </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div >
                  <div className="x-modal modal " id="luckyWheelConditionModal" tabIndex={-1} role="dialog" aria-hidden="true" data-loading-container=".js-modal-content" data-ajax-modal-always-reload="true">
                    <div className="modal-dialog -modal-size  modal-dialog-centered modal-dialog-scrollable -modal-medium" role="document">
                      <div className="modal-content -modal-content">
                        <button type="button" className="close f-1 " data-dismiss="modal" aria-label="Close">
                          <i className="fas fa-times" />
                        </button>
                        <div className="modal-header -modal-header">
                          <h3 className="x-title-modal d-inline-block m-auto">
                            {t(this.lang, 'wheel_conditions_title')}
                          </h3>
                        </div>
                        <div className="modal-body -modal-body">
                          <div className="x-lucky-wheel-condition-container">
                            <p>{t(this.lang, 'wheel_cond_deposit')}<br />
                              {t(this.lang, 'wheel_cond_reset_prefix')} <span style={{ color: '#f39c12' }}><u><strong>{t(this.lang, 'wheel_cond_reset_value')}</strong></u></span> {t(this.lang, 'wheel_cond_reset_suffix')}</p>
                            <p><span style={{ color: '#e74c3c' }}>{t(this.lang, 'wheel_cond_ticket_note')} {t(this.lang, 'wheel_cond_no_entry')}</span></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="x-modal modal  " id="luckyWheelResultModal" tabIndex={-1} role="dialog" aria-hidden="true" data-loading-container=".js-modal-content" data-ajax-modal-always-reload="true">
                    <div className="modal-dialog -modal-size  modal-dialog-centered modal-dialog-scrollable " role="document">
                      <div className="modal-content -modal-content">
                        {/* <button type="button" className="close f-1 " data-dismiss="modal" aria-label="Close">
                    <i className="fas fa-times" />
                  </button> */}
                        <div className="modal-header -modal-header">
                          <h3 className="x-title-modal d-inline-block m-auto">
                            {t(this.lang, 'm_congratulations')}
                          </h3>
                        </div>
                        <div className="modal-body -modal-body">
                          <div className="x-wheel-result-modal-container">
                            <p className="js-modal-wheel-result-description -description" />
                            <div className="-reward-image-wrapper">
                              <img alt="Website name Image" className="-img-bg img-fluid" src="https://asset.cloudigame.co/build/admin/img/wt_theme/ezc/wheel-reward-effect-bg.png" />
                              <img src alt={t(this.lang, 'lucky_wheel_alt')} className="js-modal-wheel-result-image -img img-fluid" />
                            </div>
                            <button className="btn -btn-close-modal" data-dismiss="modal">
                              {t(this.lang, 'close')}
                            </button>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div >
              </div >

            </div>
          </div>
        </div>

      </>
    );
  }
}
export default App;

